module.exports = __webpack_public_path__ + "img/海量优质数据-下层.37a4bb1b.png";